import * as ko from "knockout";
import {IMessageData, IRouteDefinitionParams, ISystem, ISystemRole} from "../../index";
import {KOSubscriptionTracker} from "../../util/KOSubscriptionTracker";
import {createErrorMessage} from "../../util/misc";
import {nsRoute} from "../../util/route";
import {getHash} from "../../constants/RouteDefinitions";
import {REQUEST_MESSAGE} from "../../constants/Language";
import {global} from "../../appContext";
import {getSearchSystemParams} from "../../util/request";
import {MAX_RESULTS_PER_PAGE} from "../../constants";
import ParsedRouteDataDecorator = nsRoute.ParsedRouteDataDecorator;
import {nsGroup} from "./nsGroup";
import used_inHtml from './used-in.html?raw';

export let template = used_inHtml;

interface IUsedIn {
    system: ISystem
    roles: ISystemRole[]
}

export class viewModel extends ParsedRouteDataDecorator {
    private data: IUsedIn[] = [];
    private readonly isReady: KnockoutObservable<boolean | null> = ko.observable(null);
    private readonly kosub: KOSubscriptionTracker = new KOSubscriptionTracker();
    private readonly messageData: KnockoutObservable<IMessageData | null> = ko.observable(null);
    private readonly req = global.getPromiseRequest('searchsystem');

    constructor(params: IRouteDefinitionParams) {
        super(params);
        this.init();
    }

    private init(): Promise<any> {
        this.isReady(false);
        this.messageData({message: REQUEST_MESSAGE});
        // Own searchsystem request — shell shares getobject (IObjectData) via __requestRouteData.
        return this.req
            .request(getSearchSystemParams({resultsprpage: MAX_RESULTS_PER_PAGE}))
            .then((data: ISystem[]) => {
                this.data = data.reduce((arr: any, system: ISystem) => {
                    const roles = system.roles.filter(r => nsGroup.isRolePartOfGroup(r, this.__id!))
                    if (!roles.length) {
                        return arr
                    }
                    return arr.concat({
                        system: system,
                        roles: roles
                    })
                }, [])
                if (this.data.length) {
                    this.messageData(null);
                    this.isReady(true);
                } else {
                    this.messageData({message: 'no data'});
                    this.isReady(false);
                }
            })
            .catch((reason: string) => {
                this.messageData(createErrorMessage(String(reason)))
            })
        ;
    }

    private getHash(system: ISystem) {
        return getHash('systemaccessdetails', {id: system.id})
    }

    override dispose() {
        super.dispose();
        this.kosub.unsuscribeAll();
        this.req.abort();
    }
}
